import { Box, Button } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import ItemCount from "../../../../utils/ItemCount";
import SRATable from "../SRATable";

const FinanceProcessorDashboard = () => {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("activeTab") || "PENDING",
  );
  const [isLoading, setIsLoading] = useState(true);
  const [sras, setSras] = useState();
  const [pendingCount, setPendingCount] = useState();
  const [questionCount, setQuestionCount] = useState();

  useEffect(() => {
    const getPendingCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/all-forms/count-all-proceed/invoice?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        setPendingCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getPendingCount();
    const getQuestionCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/all-forms/count-all-proceed/question?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        setQuestionCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getQuestionCount();
    localStorage.setItem("dashboard", JSON.stringify("INVOICE"));
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === "PENDING") {
      const getSRAs = async () => {
        setSras();
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/all-forms/all-proceed/invoice?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
          );
          setSras(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getSRAs();
    } else {
      const getSRAs = async () => {
        setSras();
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/all-forms/all-proceed/question?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
          );
          setSras(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getSRAs();
    }
  }, [activeTab]);

  return (
    <Box sx={{ textAlign: "center" }}>
      <Box className="dashboard-container" sx={{ height: 400, width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
            borderBottom: "1px solid #D1D1D1",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
            }}
          >
            <Button
              className={`dashboard-btns ${
                activeTab === "PENDING" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("PENDING");
                setIsLoading(true);
                localStorage.setItem("activeTab", "PENDING");
              }}
            >
              Process
              <ItemCount count={pendingCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "QUESTIONS" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("QUESTIONS");
                setIsLoading(true);
                localStorage.setItem("activeTab", "QUESTIONS");
              }}
            >
              Finance Query
              <ItemCount count={questionCount} />
            </Button>
          </Box>
        </Box>
        <SRATable sras={sras} activeTab={activeTab} isLoading={isLoading} />
      </Box>
    </Box>
  );
};

export default FinanceProcessorDashboard;
